import { render, staticRenderFns } from "./OshaSubIndex.vue?vue&type=template&id=489ce924"
import script from "./OshaSubIndex.vue?vue&type=script&lang=js"
export * from "./OshaSubIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports